import React from 'react';

import FilterImage from './FilterImage';
import FilterGradient from './FilterGradient';
import FilterColor from './FilterColor';

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staticUrl: props.staticUrl,
      filter_type: props.filter_type,
      filter_color: props.filter_color,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
      filter_image_url: props.filter_image_url,
      widget_hide_background: props.widget_hide_background,
    };
  }

  componentWillReceiveProps(nextProps) {
    const filter = document.getElementById('hu-filter');
    if (!filter) return;
    if (nextProps.filter_type === 'none')
      filter.className = filter.className.replace(/active/g, '');
    else 
      filter.className = 'active';
  }

  render() {
    const {
      staticUrl,
      filter_type,
      filter_color,
      filter_gradient_from,
      filter_gradient_to,
      filter_image_url,
      widget_hide_background,
    } = this.props;
    const active = filter_type !== 'none';
    
    return ( !widget_hide_background &&
      <div id="hu-filter" className={ active ? 'active' : '' }>
        <FilterGradient
          filter_type={filter_type}
          filter_gradient_from={filter_gradient_from}
          filter_gradient_to={filter_gradient_to}
        />
        <FilterColor
          filter_type={filter_type}
          filter_color={filter_color}
        />
        <FilterImage
          filter_type={filter_type}
          filter_image_url={filter_image_url}
        />
      </div>
    );
  }
}

export default Filter;


// WEBPACK FOOTER //
// ./app/js/components/filter/Filter.js